/* eslint-disable */

import { Swiper, Pagination, Navigation, Autoplay, EffectFade } from 'swiper';

const breakpoint = window.matchMedia('(min-width: 1224px)');
Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

//homepage banner carousel
(function (Drupal, $) {
  Drupal.behaviors.homepageBannerCarousel = {
    attach: function (context, settings) {
      'use strict';

      $('.homepage-hero-banner-carousel', context)
        .once('processed')
        .each(function () {
          const slider = new Swiper('.homepage-hero-banner-carousel .swiper-container', {
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
            },
            effect: 'fade',
            speed: 700,
            loop: true,
            slidesPerView: 1,
            a11y: true,
            keyboardControl: true,
            grabCursor: false,
            autoHeight: false,
            navigation: {
              nextEl: '.homepage-hero-banner-carousel .swiper-button-next',
              prevEl: '.homepage-hero-banner-carousel .swiper-button-prev',
            },
            pagination: {
              el: '.homepage-hero-banner-carousel .swiper-pagination',
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + ' custom-pagination-dot" data-index="' + index + '"></span>';
              },
            },
            on: {
              init: function () {
                var dots = document.querySelectorAll('.swiper-pagination-bullet');
                setTimeout(() => {
                  dots.forEach(function (dot) {
                    dot.classList.add('ready');
                  });
                }, 1);
              },

              slideChange: function () {
                $('.pagination-dot-paused').removeClass('pagination-dot-paused');
              },
            },
          });

          // pagination pause/play
          $(slider.pagination.el).on('click', '.custom-pagination-dot', function () {
            if ($(this).hasClass('swiper-pagination-bullet-active')) {
              console.log(slider);
              if (slider.autoplay.running) {
                slider.autoplay.stop();
                $(this).addClass('pagination-dot-paused');
              } else {
                slider.autoplay.start();
                $(this).removeClass('pagination-dot-paused');
              }
            }
          });
        });

      $('.hero-text-block .field--name-field-body')
        .once('hero-text-block')
        .each(function () {
          const $overviewText = $(this);

          const threshold = 180;

          function getTextLengthOfPTags(element) {
            let length = 0;
            element.find('p').each(function () {
              length += $(this).text().trim().length;
            });
            return length;
          }

          function setMaxHeight() {
            const initialHeight = $overviewText.prop('scrollHeight') + 'px';
            $overviewText.css('max-height', initialHeight);
          }

          if (window.innerWidth <= 768 && getTextLengthOfPTags($overviewText) > threshold) {
            $overviewText.addClass('limited closed');
            setMaxHeight();

            $overviewText.after(`<button tabindex="0" class="toggle-btn">Read more</button>`);

            $('.toggle-btn').on('click keydown', function (event) {
              if (event.type === 'click' || event.keyCode === 32 || event.keyCode === 13) {
                if ($overviewText.hasClass('closed')) {
                  $overviewText.removeClass('closed').addClass('opened');
                  $(this).text('Show less');
                } else {
                  $overviewText.removeClass('opened').addClass('closed');
                  $(this).text('Read more');
                }
              }
            });
          }

          $(window).on('resize', function () {
            setMaxHeight();

            if (window.innerWidth <= 768) {
              if (getTextLengthOfPTags($overviewText) > threshold && !$('.toggle-btn').length) {
                $overviewText.addClass('limited').after(`<button tabindex="0" class="toggle-btn">Read more</button>`);

                $('.toggle-btn').on('click keydown', function (event) {
                  if (event.type === 'click' || event.keyCode === 32 || event.keyCode === 13) {
                    if ($overviewText.hasClass('closed')) {
                      $overviewText.removeClass('closed').addClass('opened');
                      $(this).text('Show less');
                    } else {
                      $overviewText.removeClass('opened').addClass('closed');
                      $(this).text('Read more');
                    }
                  }
                });
              } else if (getTextLengthOfPTags($overviewText) <= threshold) {
                $overviewText.removeClass('limited opened closed');
                $('.toggle-btn').remove();
              }
            } else {
              $('.toggle-btn').remove();
            }
          });
        });
    }, //attach
  };
})(Drupal, jQuery);

function latestUpdatesSwiper() {
  const slider = new Swiper('.latest-updates .latest-updates-swiper', {
    loop: false,
    spaceBetween: 10,
    centeredSlidesBounds: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    a11y: true,
    keyboardControl: true,
    grabCursor: false,
    autoHeight: false,
    navigation: {
      nextEl: '.latest-updates .swiper-button-next',
      prevEl: '.latest-updates .swiper-button-prev',
    },
    pagination: {
      el: '.latest-updates .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 3,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });
}

window.addEventListener('load', () => {
  latestUpdatesSwiper();
});
